import React from 'react';
import { useFormContext, useFieldArray } from 'react-hook-form';
import { Box, Typography, Button } from '@mui/material';
import TabSaveButton from './TabSaveButton';
import DrugInfoCard from './DrugInfoCard';

export default function DrugInfoForm(tabIndex) {
  const { control } = useFormContext();

  // 최상위 drugInfos 배열만 여기에서 훅 호출
  const { fields: drugFields, append: drugAppend, remove: drugRemove } = useFieldArray({ control, name: 'drugInfos' });

  const FIELD_PATHS = ['groupId', 'drugInfos'];

  return (
    <Box>
      <Typography variant="h6" sx={{ mb: 2 }}>
        다. 의약품 등 정보
      </Typography>

      {drugFields.map((drug, di) => (
        <DrugInfoCard key={drug.id} index={di} removeCard={() => drugRemove(di)} />
      ))}

      <Button
        variant="outlined"
        size="small"
        onClick={() =>
          drugAppend({
            herbalPrescription: {
              drugName: '',
              totalPrescriptions: '',
              totalPacks: '',
              packsPerDay: '',
              packVolumeMl: '',
              decoctionPlace: '',
              herbCompositions: [{ herbName: '', amountGram: '' }], // 기본 1개
              itemInfos: [{ itemHerbName: '', companyName: '', origin: '' }], // 기본 1개
            },
            drugAdministrationFetus: {
              routeParent: '',
              firstExposureGestation: { value: '', unit: '' },
            },
            adverseEventTreatment: '',
            concomitantTherapy: '',
            concomitantDrugs: [],
            pastHistory: '',
            adverseEventRelevance: [],
          })
        }
      >
        의약품 정보 추가
      </Button>

      <Box sx={{ mt: 2 }}>
        <TabSaveButton fieldPaths={FIELD_PATHS} label="탭 저장" index={tabIndex} />
      </Box>
    </Box>
  );
}
